import { Box, Typography } from "@mui/material";

function TextCod({ title, text }) {
  return (
    <Box display="flex" marginBottom={2}>
      <Typography variant="h5" color="text.secondary">
        {title}{" "}
      </Typography>

      <Typography variant="h5" color="secondary.main" paddingRight={4}>
        {text}
      </Typography>
    </Box>
  );
}

export default TextCod;
